enum ActionTypes {
	request = 'ProductSearchableDataSource.request',
	requestGrouped = 'ProductSearchableDataSource.requestGrouped',
	receive = 'ProductSearchableDataSource.receive',
	receiveGrouped = 'ProductSearchableDataSource.receiveGrouped',
	updatedSelectedTypes = 'ProductSearchableDataSource.updatedSelectedTypes',
}

export default ActionTypes;
